/*
 * Module for the Drop Interest Process Job View
 */
rs.module("content/jobs/criteria/dropinterestprocesscontract",

    [
        "common/select-helper",
        "controls/components/event-banner",
        "common/visibility"
    ],

    function (selectHelper, eventBanner, visibility) {

        // Initialize the page
        function initialize(jsSelectors, cssClasses, backendUrl, canRetrieve) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);

            var dropPlanSelect = criteria.js(jsSelectors.dropPlanSelect);

            var interestParametersContainer = criteria.js(jsSelectors.interestParametersContainer);
            var interestParameterPanel = interestParametersContainer.js(jsSelectors.interestParameterPanel);

            var interestParameterItem = interestParametersContainer.js(jsSelectors.interestParameterItem);
            var interestFrequencyText = interestParametersContainer.js(jsSelectors.interestFrequencyText);
            var annualInterestRateText = interestParametersContainer.js(jsSelectors.annualInterestRateText);
            var periodicInterestRateText = interestParametersContainer.js(jsSelectors.periodicInterestRateText);
            var interestBalancesAsOfText = interestParametersContainer.js(jsSelectors.interestBalancesAsOfText);
            var postInterestOnText = interestParametersContainer.js(jsSelectors.postInterestOnText);

            var interestParameterEmpty = interestParametersContainer.js(jsSelectors.interestParameterEmpty);

            var readonlySection = criteria.js(jsSelectors.readonlySection);
            var monthYearText = readonlySection.js(jsSelectors.monthYearText);
            var balanceAsOfDateText = readonlySection.js(jsSelectors.balanceAsOfDateText);
            var postingDateText = readonlySection.js(jsSelectors.postingDateText);

            var editableSection = criteria.js(jsSelectors.editableSection);
            var processingMonthSelect = editableSection.js(jsSelectors.processingMonthSelect);
            var processingYearInput = editableSection.js(jsSelectors.processingYearInput);

            // Use select helper for working with select lists
            var processingMonthSelectHelper = selectHelper.getHelper(processingMonthSelect);

            // Setup on change event.
            dropPlanSelect.change(planSelected);

            // Run on-load methods
            if (!canRetrieve) {
                planSelected();
            }

            // show/hide interest parameters on hover
            interestParametersContainer.hoverIntent({
                handlerOver: function (event) {
                    interestParameterPanel.toggleClass(cssClasses.visible, true);
                },
                handlerOut: function (event) {
                    interestParameterPanel.toggleClass(cssClasses.visible, false);
                },
                hoverOutDelay: 400
            });

            // On plan selection change, handle population of associated drop deposit batch fields.
            function planSelected() {

                // Remove event banner messages
                eventBanner.removeAllMessages();

                // hide plan parameters
                interestParameterItem.toggleClass(cssClasses.hidden, true);
                interestParameterEmpty.toggleClass(cssClasses.hidden, true);

                // get selected plan
                var selectedPlanKey = dropPlanSelect.val();

                if (selectedPlanKey != null) {
                    // load new drop deposit batch from backend.
                    $.getJSON(backendUrl, { dropPlanKey: selectedPlanKey }).done(function (result) {
                        if (result.firstBatchFlag) {

                            ShowEditFields(true);

                            // clear defaults
                            processingMonthSelectHelper.setValue('');
                            processingMonthSelect.clearErrors();
                            processingYearInput.val('').clearErrors();
                        }
                        else {

                            ShowEditFields(false);

                            // prevent hidden fields from causing validation issues
                            processingMonthSelectHelper.setValue(1);
                            processingMonthSelect.clearErrors();
                            processingYearInput.val(new Date().getFullYear()).clearErrors();

                            // Populate display fields
                            monthYearText.text(result.processingMonthYear);

                            balanceAsOfDateText.text(result.balanceAsOfDate);
                            postingDateText.text(result.postingDate);
                        }

                        // Determine whether to populate the Interest Parameter Hover Box
                        if (result.interestFrequency != '') {
                            // Populate Hover Popup
                            interestBalancesAsOfText.text(result.interestBalancesAsOf);
                            interestFrequencyText.text(result.interestFrequency);
                            annualInterestRateText.text(result.annualInterestRate);
                            periodicInterestRateText.text(result.periodicInterestRate);
                            postInterestOnText.text(result.postInterestOn);

                            interestParameterItem.toggleClass(cssClasses.hidden, false);
                        }
                        else {
                            interestParameterEmpty.toggleClass(cssClasses.hidden, false);

                        }
                    }).fail(function () {
                        interestParameterItem.toggleClass(cssClasses.hidden, true);
                        interestParameterEmpty.toggleClass(cssClasses.hidden, true);
                        visibility.hide(readonlySection);
                        visibility.hide(editableSection);
                    });
                }
            }

            // Shows or Hides the readonly or editable fields depending on input
            function ShowEditFields(isFirstBatch) {

                visibility.setVisible(readonlySection, !isFirstBatch);
                visibility.setVisible(editableSection, isFirstBatch);
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);